import { POST_API } from 'middlewares/form';
import root from 'window-or-global';


export const HANDLE_ADMIN_TOGGLE_LINK_REQUEST = 'HANDLE_ADMIN_TOGGLE_LINK_REQUEST';
export const HANDLE_ADMIN_TOGGLE_LINK_SUCCESS = 'HANDLE_ADMIN_TOGGLE_LINK_SUCCESS';
export const HANDLE_ADMIN_TOGGLE_LINK_FAILURE = 'HANDLE_ADMIN_TOGGLE_LINK_FAILURE';
export const handleAdminToggleLink = ({ endpoint, isStaff }) => ({
  [POST_API]: {
    endpoint,
    types: [
      HANDLE_ADMIN_TOGGLE_LINK_REQUEST,
      HANDLE_ADMIN_TOGGLE_LINK_SUCCESS,
      HANDLE_ADMIN_TOGGLE_LINK_FAILURE,
    ],
    payload: {},
    onSuccess: () => {
      if (isStaff) {
        // just retaining the current implementation
        root.location.reload();
      }
    },
  },
});


export const handleCurateLink = ({ endpoint }) => ({
  [POST_API]: {
    endpoint,
    types: [
      '__',
      '__',
      '__',
    ],
    payload: {},
    onSuccess: () => {
      root.location.reload();
    },
  },
});



// WEBPACK FOOTER //
// ./src/admin/actions/index.js